'use client';

import { motion } from 'framer-motion';
import { CheckCircle2, Gem, Loader2 } from 'lucide-react';

interface PaymentSuccessScreenProps {
  countdown: number;
  onRedirectNow: () => void;
}

export function PaymentSuccessScreen({
  countdown,
  onRedirectNow,
}: PaymentSuccessScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="w-full max-w-sm rounded-[28px] bg-card px-7 py-10 text-center shadow-[0_8px_40px_rgba(0,0,0,0.25)]"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', delay: 0.2 }}
          className="mx-auto mb-5 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-primary/[0.12]"
        >
          <CheckCircle2 className="h-10 w-10 text-primary" />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="mb-1.5 font-benzin text-[22px] font-semibold"
        >
          Оплата успешна!
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mb-5 text-sm text-muted-foreground"
        >
          Ваш баланс пополнен
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5 }}
          className="mb-5 rounded-2xl border border-white/5 p-[18px]"
          style={{ background: 'linear-gradient(to right, hsl(82 64% 56% / 0.1), hsl(187 80% 54% / 0.1))' }}
        >
          <div className="flex items-center justify-center gap-2.5">
            <Gem className="h-[22px] w-[22px] text-cyan-400" />
            <span className="text-[15px] font-medium">Баланс обновлён</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground"
        >
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
          <span>Переход на главную через {countdown}...</span>
        </motion.div>

        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          onClick={onRedirectNow}
          className="mt-4 w-full rounded-2xl bg-primary py-3.5 text-[15px] font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Перейти сейчас
        </motion.button>
      </motion.div>
    </div>
  );
}
